import { ReactNode } from 'react'
import { signal, computed } from '@preact/signals-react'

export type SidebarTopProps = { data: any }
export type TreeTopProps = { data: any }
export type TreeNodeProps = { node: any }
export type TTreeNodeItem = {
    id: string
    label: string
    title?: string
    value: string
    refKey?: string
    refValue?: string
    visible?: boolean
}

export enum ETabSet {
    MAINTAB = 'main-tabs',
    SIDEBAR = 'sidebar',
}

export type TTabItemController = {
    // handleTabList(action: string, data: any): any,
    defaultRow?: (params?: any) => any
    removeTab?: (params?: any) => any
    getTabContent?: (params?: any) => any
    getBreadCrumb?: (params?: any) => any
    showBreadCrumb?: (params: any) => any
    useProjectInBreadCrumb?: (params?: any) => any
    ignoreProjectExists?: (params?: any) => any
}
export type TTabStore = any
export type TTabItem = {
    id: string
    dataId?: string
    name: string
    component: string
    store: TTabStore
    modified: boolean
    controller?: TTabItemController // the ontroller who used the store
    icon?: ReactNode // icon in tab before title
    context?: string
    // label: string,          // tab label
    // mode?: string,          // add, edit, etc.
    // error?: any,            // the error in the tab or false
    // autoScroll?: boolean,   // true = overflow auto
    // tabKey?: string,        // internal unique tab key
    // formData?: any,
}
export type TTabInput = Omit<TTabItem, 'id' | 'modified'> & {
    dataId: string
}
export const tabs = signal<TTabItem[]>([])
export const activeKey = signal<string>('')

export const hasOpenTabs = computed(() => tabs.value.length > 0)

export const currentTab = computed(() => findTab(activeKey.value))

export function updateCurrentTab(changes: Partial<TTabItem>) {
    const index = tabs.value.findIndex((tab) => tab.id === activeKey.value)
    if (index === -1) return

    const updatedTabs = [...tabs.value]
    updatedTabs[index] = {
        ...updatedTabs[index],
        ...changes,
    }

    tabs.value = updatedTabs
}

export function addTab(tab: TTabInput): TTabItem {
    const existing = tabs.value.find((t) => t.dataId === tab.dataId)
    const sharedStore = existing ? existing.store : (tab.store ?? {})

    const instanceId = `${tab.dataId}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`

    const newTab: TTabItem = {
        ...tab,
        id: instanceId,
        store: sharedStore,
        modified: false,
    }
    //console.log(newTab)

    tabs.value = [...tabs.value, newTab]
    setActiveKey(newTab.context || 'main-tabs', newTab.id)

    return newTab
}

export function findTab(id: string): TTabItem | null {
    return tabs.value.find((tab) => tab.id === id) || null
}
export function findTabByData(dataId: string): TTabItem | null {
    return tabs.value.find((tab) => tab.dataId === dataId) || null
}

export function getTabs(): TTabItem[] {
    return tabs.value
}

export function tabsCount(): number {
    return tabs.value.length
}

export function removeTab(tabOrKey: string | TTabItem) {
    const id = typeof tabOrKey === 'string' ? tabOrKey : tabOrKey.id
    // const index = tabs.value.findIndex(t => t.id === id)
    // if (index > -1) {
    //     const newTabs = [...tabs.value]
    //     newTabs.splice(index, 1)
    //     tabs.value = newTabs
    //     if (activeKey.value === id && newTabs.length > 0) {
    //         activeKey.value = newTabs[Math.max(0, index - 1)].id
    //     } else if (newTabs.length === 0) {
    //         activeKey.value = ''
    //     }
    // }
    tabs.value = tabs.value.filter((t) => t.id !== id)
}

export function setTabModified(id: string, modified: boolean) {
    tabs.value = tabs.value.map((t) => (t.id === id ? { ...t, modified } : t))
}

/**
 * A tab follows the name of what it shows: after a rename was saved, the tab
 * kept the old one (operator, 13.10.2026). The layout renames its node when
 * this changes.
 */
export function setTabName(id: string, name: string) {
    if (!name) return
    tabs.value = tabs.value.map((t) => (t.id === id && t.name !== name ? { ...t, name } : t))
}

export const isTabOpen = (id: string) => tabs.value.some((t) => t.id === id)

// NEW STUFF
export const activeKeys = signal<Record<string, string>>({})
export function getActiveKey(context: string): string {
    return activeKeys.value[context] || ''
}

export function setActiveKey(context: string, key: string) {
    activeKeys.value = { ...activeKeys.value, [context]: key }
}
export function updateTabContext(tabId: string, newContext: string) {
    tabs.value = tabs.value.map((tab) => (tab.id === tabId ? { ...tab, context: newContext } : tab))
}

export const activeContext = signal<string>(ETabSet.MAINTAB)

export function getActiveContext(): string {
    return activeContext.value || ETabSet.MAINTAB
}
export const lastNonSidebarContext = signal<string>(ETabSet.MAINTAB)

export function setActiveContext(context: string) {
    activeContext.value = context
    if (context !== ETabSet.SIDEBAR) {
        lastNonSidebarContext.value = context
    }
}

export function getLastNonSidebarContext(): string {
    return lastNonSidebarContext.value || ETabSet.MAINTAB
}
export default {
    tabs,
    activeKey,
    hasOpenTabs,
    currentTab,
    updateCurrentTab,
    addTab,
    findTab,
    findTabByData,
    getTabs,
    tabsCount,
    removeTab,
    getActiveKey,
    setActiveKey,
    setTabModified,
    isTabOpen,
    updateTabContext,
    activeContext,
    setActiveContext,
    getActiveContext,
    lastNonSidebarContext,
    getLastNonSidebarContext,
}
